import EventBase from './EventBase'
import EventID from './EventID'
import {
    ensureAudioPlayParameters,
    readAudioPlaySeconds,
    readAudioPlayTrack,
    writeAudioPlaySeconds,
    writeAudioPlayTrack,
} from './audioEventShared'

/**
 * 503  -  播放语音
 */
export default class EventStartVoice extends EventBase {
    /**
     * 构造函数
     */
    constructor() {
        super()
        this.Parameter = ensureAudioPlayParameters(['', '50', '', '2', '0', '0', '1', '0', '0'])
    }

    // #region 事件内关键属性参数
    /**
     * 语音的相对路径
     */
    get Path() {
        return this.Parameter?.[0] ?? ''
    }
    set Path(value) {
        this.Parameter && (this.Parameter[0] = value.toString())
    }

    /**
     * 音量
     */
    get Vol() {
        return parseInt(this.Parameter?.[1] ?? '')
    }
    set Vol(value) {
        this.Parameter && (this.Parameter[1] = value.toString())
    }

    /**
     * 时间单位：0 帧，1 秒
     */
    get TimeUnit() {
        return parseInt(this.Parameter[6])
    }

    set TimeUnit(val) {
        this.Parameter[6] = val ? '1' : '0'
    }

    /**
     * 淡入时间
     */
    get Time() {
        return readAudioPlaySeconds(this.Parameter)
    }

    set Time(val) {
        this.Parameter = writeAudioPlaySeconds(this.Parameter, val)
    }

    /**
     * 是否淡入
     */
    get IsFade() {
        return this.Parameter[4] === '1'
    }

    set IsFade(val) {
        this.Parameter[4] = val ? '1' : '0'
    }

    /**
     * 显示信息
     */
    get Description() {
        const time = this.Time
        return this.Parameter?.[2] === '无'
            ? '无'
            : this.Parameter?.[2] +
                  `，音量 ${this.Vol} ${
                      this.IsFade ? '淡入 ' + time + [' 帧', ' 秒'][this.TimeUnit] : ''
                  }`
    }
    set Description(value) {
        this.Parameter && (this.Parameter[2] = value.toString())
    }

    /// <summary>
    /// 网盘还是本地
    /// 2是（网盘）
    /// </summary>
    get IsPublicwebdisk() {
        return this.Parameter?.[3] === '2'
    }
    set IsPublicwebdisk(value) {
        this.Parameter && (this.Parameter[3] = value ? '2' : '1')
    }

    get MillSecondTime() {
        return Number(this.Parameter?.[7] ?? '0') || 0
    }
    set MillSecondTime(value) {
        this.Parameter = ensureAudioPlayParameters(this.Parameter)
        this.Parameter[7] = String(value ?? 0)
    }

    get AudioIndex() {
        return readAudioPlayTrack(this.Parameter)
    }
    set AudioIndex(value) {
        this.Parameter = writeAudioPlayTrack(this.Parameter, value)
    }

    //   // #endregion

    /**
     * 事件ID
     */
    Code = EventID.StartVoice

    /**
     * 获得该事件在事件列表的描述信息
     */
    /// <returns>事件描述信息</returns>
}
